import React, { FunctionComponent } from 'react'

import InsightCard from './InsightCard'
import SalesforceTaskCard from './SalesforceTaskCard'

interface CardFactoryProps {
  data: Record<string, any>
}

const Cards: Record<string, FunctionComponent> = {
  DRIFT_INSIGHT: InsightCard,
  SALESFORCE: SalesforceTaskCard
}

const CardFactory = ({ data }: CardFactoryProps) => {
  const { cardType } = data as any
  const Card = Cards[cardType]

  if (!Card) {
    return null
  }
  return <Card {...data} />
}

export default CardFactory
